jQuery( document ).ready(function( $ ) {

  //MAIN MENU HEADER FADE OUT
  var header = $("#header");
  var CurrentScroll = $(this).scrollTop();;

  if($('#toolbar-administration').length >  0) {
    $(header).addClass("fix-margin");
  }
  if($('#page-wrapper').hasClass('transparent-header') && !$('.node .header').hasClass('header-no-image') && $('.node .header').length) {
    if(CurrentScroll > $('.node .header').height()){
      $('#header').removeClass('transparent-active');
    } else {
      $('#header').addClass('transparent-active');
      $('#header').parent().addClass('transparent-header-active');
    }
  }

  $(window).scroll(function(event) {
    var NextScroll = $(this).scrollTop();
    if(NextScroll > CurrentScroll) {
      if(CurrentScroll > 70) {
        if ((NextScroll - CurrentScroll) >= 15) {
          if($('#toolbar-administration').length >  0) {
            $(header).removeClass("fix-margin");
          }
          header.removeClass("active");
        }
      }
    } else {
      if ((NextScroll - CurrentScroll) <= -15) {
        if($('#toolbar-administration').length >  0) {
          $(header).addClass("fix-margin");
        }
        header.addClass("active");
      }
    }
    if($('#page-wrapper').hasClass('transparent-header') && !$('.node .header').hasClass('header-no-image')) {
      if(CurrentScroll > $('.node .header').height()){
        $('#header').removeClass('transparent-active')
      } else {
        $('#header').addClass('transparent-active')
      }
    }
    CurrentScroll = NextScroll;
  });

  if($(window).width() < 940) {
      $(".main-menu li.has-sub").click(function(e) {
          $(this).toggleClass("active");
          $(this).children("ul").slideToggle();
      });
      $(".main-menu li.has-sub > a").click(function(e) {
          e.preventDefault();
      });

  } else {

      $(".main-menu li.has-sub").hover(function () {
          $(this).children("a").click(function () {
              return false;
          });
      });
  }


    //MENU MOBILE
  $( ".mobilemenubtn" ).click(function() {
    var CurrentScroll = $(window).scrollTop();
    console.log(CurrentScroll + " - " + $('.node .header').height());
    $("#hamburger-toggle").toggleClass("active");
    if($(".mobilemenu-wrapper").hasClass("active")) {
      $(".mobilemenu-wrapper").removeClass("active");
      $(".mobilemenu-wrapper").addClass("fadeOutRight");
      $(".mobilemenu-wrapper").removeClass("fadeInRight");
      if($('#page-wrapper').hasClass('transparent-header') && !$('.node .header').hasClass('header-no-image')) {
        if (CurrentScroll < $('.node .header').height()) {
          $(this).parent().parent().addClass("transparent-active");
        }
      }
    } else {
      $(".mobilemenu-wrapper").removeClass("initial");
      $(".mobilemenu-wrapper").addClass("active");
      $(".mobilemenu-wrapper").addClass("fadeInRight");
      $(".mobilemenu-wrapper").removeClass("fadeOutRight");
      if($('#page-wrapper').hasClass('transparent-header') && !$('.node .header').hasClass('header-no-image')) {
        if (CurrentScroll < $('.node .header').height()) {
          $(this).parent().parent().removeClass("transparent-active");
        }
      }
    }
  });


  //SCROLLER
  $('#main-wrapper .header-inner .button a').click(function(e) {
    e.preventDefault()
    console.log($(this).attr("href"));
    var btnHref = $(this).attr("href");
    if(btnHref.startsWith("#")) {
      var scrollISelector = btnHref.replace('#', '');
      if($("#"+scrollISelector).length > 0) {
        $('html, body').animate({
          scrollTop: $("#" + scrollISelector).offset().top
        }, 1000)
      }
    }
  });
});
